function applyBoldScript() {
  if(window.BOLD && BOLD.common){
    setTimeout(function() {

      if (document.querySelector('.bold_option_total')) {
          var divContent = document.querySelector('.bold_option_total > div span').textContent;
          var label = divContent.split(': ')[0];
          var value = parseFloat(divContent.replace("$", "").replace(",", ""));
          var totalLabel = divContent.split(' ').slice(-2).join(' ');
  
          var c_price = parseFloat(document.querySelector('.compareprice_bold_option_price_display').getAttribute('data-c-price').replace("$", "").replace(",", ""));
          var c_total = (c_price + value).toFixed(2);
  
          var m_price = parseFloat(document.querySelector('.bold_option_price_display').getAttribute('data-m-price').replace("$", "").replace(",", ""));
          var m_total = (m_price + value).toFixed(2);
  
          if (c_total > 0) {
              document.querySelector('.compareprice_bold_option_price_display').innerHTML = '$' + numberWithCommas(c_total);
          }
          if (m_total > 0) {
              document.querySelector('.bold_option_price_display').innerHTML = '$' + numberWithCommas(m_total);
          }
        
      } else {
             var c_price_only = document.querySelector('.compareprice_bold_option_price_display').getAttribute('data-c-price');
             var m_price_only = document.querySelector('.bold_option_price_display').getAttribute('data-m-price')
             if (c_price_only) {
              document.querySelector('.compareprice_bold_option_price_display').innerHTML = c_price_only
            }
            if (m_price_only) {
              document.querySelector('.bold_option_price_display').innerHTML = m_price_only;
           }   
      }
    }, 200);

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    }
}

function handleInputChanges(event) {
// console.log("event.target.tagName",event.target)
  if (event.target.tagName === "INPUT" || event.target.tagName === "SELECT") {
    applyBoldScript();
  }
}

function observeDOM() {
  var observer = new MutationObserver(function(mutationsList) {
    for (var mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded')) {
          applyBoldScript();
            document.querySelectorAll(".bold_option .bold_option_element input,.bold_option .bold_option_element select").forEach(function(element) {
              element.addEventListener('change', function() {
                applyBoldScript();
             })
          })

            $('.bold_option_value').mouseover(function() {
                var x = $(this).position();
                var right = $(window).width() - x.left - $(this).width();
                if(x.left < 205){
                    $(this).addClass('tooltip-left-pos');
                }
                if(right < 160){
                    $(this).addClass('tooltip-right-pos');
                }
            });
            $(window).width()<=768&&$('.bold_option_value').each(function(){
                var t=$(this).position(),i=$(window).width()-t.left-$(this).width(),o=t.left-i;
                o<50&&o>-50?$(this).addClass('tooltip-center-pos'):t.left<i?$(this).addClass('tooltip-left-pos'):i<t.left&&$(this).addClass('tooltip-right-pos')
            }); 
          observer.disconnect();
          break;
        }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', function() {
  observeDOM();
// Attach event listener for input changes using event delegation
  document.body.addEventListener('change', handleInputChanges);
});
